const alphanumericPattern = /^[ A-Za-z0-9_./# &+-]*$/;
const doubleCurlyBraces = '[^{{}]+(?=}})';
const alphabetsOnly = '^[A-Za-z]*$';
const urlPattren =
  '^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$';
const alphaUnderscoreOnly = /^[a-zA-z]+([_][a-zA-Z]+)*$/;
const resetPasswordPattern = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;

export {
  alphanumericPattern,
  resetPasswordPattern,
  doubleCurlyBraces,
  alphabetsOnly,
  urlPattren,
  alphaUnderscoreOnly,
};
